import { Message } from '../types/Agent';

export interface AppInfo {
  url?: string;
  appId?: string;
  status?: string;
}

export function extractLatestAppInfoFromMessages(messages?: Message[]): AppInfo {
  if (!messages) return {};
  
  // Scan newest → oldest, assistant only
  for (let i = messages.length - 1; i >= 0; i--) {
    const m = messages[i];
    if (m.role !== 'assistant' || !m.content) continue;
    
    // First, try to extract app-info fence (preferred)
    {
      const appInfoRe = /```app-info\s*\n([\s\S]*?)\n```/g;
      const appInfoMatches: RegExpExecArray[] = [];
      let appMatch: RegExpExecArray | null;
      while ((appMatch = appInfoRe.exec(m.content)) !== null) {
        appInfoMatches.push(appMatch);
      }
      for (let j = appInfoMatches.length - 1; j >= 0; j--) {
        try {
          const obj = JSON.parse(appInfoMatches[j][1].trim());
          const url = typeof obj?.appURL === 'string' ? obj.appURL : undefined;
          const appId = typeof obj?.appId === 'string' ? obj.appId : undefined;
          const status = typeof obj?.status === 'string' ? obj.status : undefined;
          
          if (url || appId || status) {
            return { url, appId, status };
          }
        } catch {
          // Invalid JSON, skip
        }
      }
    }
    
    // Fallback: Extract from tool-result fences
    {
      const toolResultRe = /```tool-result\s*\n([\s\S]*?)\n```/g;
      const toolResultMatches: RegExpExecArray[] = [];
      let toolMatch: RegExpExecArray | null;
      while ((toolMatch = toolResultRe.exec(m.content)) !== null) {
        toolResultMatches.push(toolMatch);
      }
      for (let j = toolResultMatches.length - 1; j >= 0; j--) {
        try {
          const obj = JSON.parse(toolResultMatches[j][1].trim());
          const url = typeof obj?.appURL === 'string' ? obj.appURL : undefined;
          const appId = typeof obj?.appId === 'string' ? obj.appId : undefined;
          const status = typeof obj?.status === 'string' ? obj.status : undefined;
          
          if (url || appId || status) {
            return { url, appId, status };
          }
        } catch {
          // Invalid JSON, skip
        }
      }
    }
  }
  
  return {};
}

